import template from './configurehelpscout.html';
import controller from './configurehelpscout.controller';
import './configurehelpscout.scss';

let configurehelpscoutComponent = {
  restrict: 'E',
  bindings: {
    resolve: '<',
    close: '&',
    dismiss: '&'
  },
  template,
  controller
};

export default configurehelpscoutComponent;



// WEBPACK FOOTER //
// ./client/app/components/home/modals/configurehelpscout/configurehelpscout.component.js